import { useEffect } from "react";
import { siteName } from "@/mocks/anime";

export default function usePageTitle(title: string) {
  useEffect(() => {
    document.title = `${title} - ${siteName}`;
  }, [title]);
}